import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStageLearn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 80,
	height: 80,
	viewBox: "0 0 80 80",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_74_155)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M48.3334 53.5173V60.76C48.3334 64.5627 45.1334 66.0933 40.3334 66.0933C35.5334 66.0933 32.3334 64.5627 32.3334 60.76V53.5173",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43 54.0933V38.0933C43 37.5659 43.1564 37.0503 43.4495 36.6118C43.7425 36.1733 44.1589 35.8315 44.6462 35.6296C45.1335 35.4278 45.6697 35.375 46.1869 35.4779C46.7042 35.5808 47.1794 35.8348 47.5523 36.2077C47.9253 36.5806 48.1792 37.0558 48.2821 37.5731C48.385 38.0904 48.3322 38.6265 48.1304 39.1138C47.9286 39.6011 47.5868 40.0176 47.1482 40.3106C46.7097 40.6036 46.1941 40.76 45.6667 40.76H35C34.2928 40.76 33.6145 40.479 33.1144 39.9789C32.6143 39.4788 32.3334 38.8006 32.3334 38.0933C32.3334 37.3861 32.6143 36.7078 33.1144 36.2077C33.6145 35.7076 34.2928 35.4267 35 35.4267C35.3552 35.4078 35.7103 35.4639 36.0424 35.5913C36.3744 35.7186 36.676 35.9144 36.9275 36.1659C37.179 36.4174 37.3747 36.7189 37.5021 37.051C37.6294 37.383 37.6855 37.7382 37.6667 38.0933V54.0933",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M47 54.0933C50.1938 52.8272 52.9258 50.6175 54.8315 47.7588C56.7373 44.9002 57.7263 41.5285 57.6666 38.0933C57.5852 33.5217 55.7328 29.1601 52.4997 25.927C49.2666 22.6938 44.9049 20.8415 40.3333 20.76C35.7617 20.8415 31.4001 22.6938 28.1669 25.927C24.9338 29.1601 23.0815 33.5217 23 38.0933C22.9404 41.5285 23.9294 44.9002 25.8351 47.7588C27.7409 50.6175 30.4728 52.8272 33.6666 54.0933H47Z",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.3334 59.4268H48.3334",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.3334 9V14.0933",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M40.3334 66.0933V70.0933",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11 35.4268H17.1093",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.9093 15.6667L23 20.7601",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M69.6667 35.4268H63.5574",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M62.7573 15.6667L57.6666 20.7601",
				stroke: "black",
				strokeWidth: 2.70833,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_74_155",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 64,
			height: 64,
			fill: "white",
			transform: "translate(8 8)"
		})
	}) })]
});
export default SvgIconStageLearn;
